export default __webpack_public_path__ + "static/media/happyman.05370b75.svg";